import { createSelector } from 'reselect'

import { getNotificationsByAssociationId } from './notifications';
import { getDocLastUpdate, getDocLastSeenByUser } from '../utils/doc';

const getDoc = (docs, docId) => docs.find(doc => doc.id === docId || doc.public_token === docId);
export const makeGetDoc = () => createSelector(getDoc, doc => doc);

const getProjectDocs = (docs, projectId, notifications = [], currentUserId) => docs.filter(doc => doc.project === projectId)
    .sort((d1, d2) => {
        const d1Notifications = !notifications.length ? 0 : getNotificationsByAssociationId(notifications, d1.id).length;
        const d2Notifications = !notifications.length ? 0 : getNotificationsByAssociationId(notifications, d2.id).length;

        if (d1Notifications > d2Notifications) return -1;
        if (d1Notifications < d2Notifications) return 1;

        const d1SortDate = getDocLastSeenByUser(d1.members, currentUserId) || getDocLastUpdate(d1.members, null, d1.created_at).date;
        const d2SortDate = getDocLastSeenByUser(d2.members, currentUserId) || getDocLastUpdate(d2.members, null, d2.created_at).date;

        return d2SortDate - d1SortDate;
    });
export const makeGetProjectDocs = () => createSelector(getProjectDocs, docs => docs);

const getActiveProjectDocs = (docs, projectId, notifications, currentUserId) => getProjectDocs(docs.filter(doc => doc && !doc.archived), projectId, notifications, currentUserId)
export const makeGetActiveProjectDocs = () => createSelector(getActiveProjectDocs, docs => docs);

const getArchivedProjectDocs = (docs, projectId, notifications) => getProjectDocs(docs.filter(doc => doc && doc.archived), projectId, notifications)
export const makeGetArchivedProjectDocs = () => createSelector(getArchivedProjectDocs, docs => docs);
